import { render, staticRenderFns } from "./csemail.vue?vue&type=template&id=2d5eb2b5&scoped=true"
import script from "./csemail.vue?vue&type=script&lang=js"
export * from "./csemail.vue?vue&type=script&lang=js"
import style0 from "./csemail.vue?vue&type=style&index=0&id=2d5eb2b5&prod&lang=scss&scoped=true"
import style1 from "./csemail.vue?vue&type=style&index=1&id=2d5eb2b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5eb2b5",
  null
  
)

export default component.exports